import React from 'react';
import styled from 'styled-components';
import { LeftArrow } from '../Icons';
import { theme } from '../../styled';
export const LinkWrapper = styled.div `
  a {
    display: flex;
    align-items: center;

    .left-arrow {
      margin-right: 8px;
    }
  }
`;
const NavLinkWithArrow = ({ url, color, text, className }) => (React.createElement(LinkWrapper, { className: `NavLinkWithArrow ${className || ''}` },
    React.createElement("a", { href: url, className: "button-nav-link" },
        React.createElement(LeftArrow, { color: color || theme.blue }),
        " ",
        text)));
export default NavLinkWithArrow;
